import { t } from '@lingui/core/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Title from '@/design_system/Typography/Title';

export const CardSection = ({
  fields,
  title,
}: {
  fields: { label?: string | null; value?: string | null }[];
  title: string;
}) => {
  const FieldDisplay = ({ label, value }: { label?: string | null; value?: string | null }) => (
    <Stack row padding="0 0 0 2em" key={label}>
      <InlineText weight="medium" style={{ width: '20%' }}>
        {label}
      </InlineText>
      <InlineText style={{ width: '80%' }}>
        {value ?? t({ id: '_general.na', message: 'N/A' })}
      </InlineText>
    </Stack>
  );

  return (
    <Box
      padding="24px"
      style={{
        marginBottom: '16px',
      }}
    >
      <Title as="h2" size="300" weight="medium" style={{ paddingBottom: '16px' }}>
        {title}
      </Title>
      {fields.map((field) => FieldDisplay({ label: field.label, value: field.value }))}
    </Box>
  );
};
